import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material'
import AppsContainer from './apps-container'
import RecommendedApp from './recommended-app'
import WizardFooter from '../WizardFooter'
import useOnboardingContext from '@/hooks/useOnboardingContext'
import { useEffect, useState } from 'react'
import { isAppEnabledForPlan } from '@/constants/onboarding'

const RecommendedApps = ({ handleExitToEditor, wizard: { title, subtitle } = {} }) => {
  const { recommendedApps, setRecommendedApps, storeOnboardingData: { isStoreOnboardingComplete, appChoices, planSku }, fetchingStoreOnboarding, fetchedStoreOnboarding} = useOnboardingContext()
  const [previousAppChoices, setPreviousAppChoices] = useState({})

  const shouldHideApp = (appId) => !isAppEnabledForPlan(appId, planSku)

  const updateSelectedApp = (index, status) => {
    const updatedRecommendedApps = [...recommendedApps]
    updatedRecommendedApps[index].enabled = status
    setRecommendedApps(updatedRecommendedApps)
  }

  const isSkippable = !(recommendedApps.some(
    (app) => !app.skippable && app.enabled && !app.disabled
  )) || recommendedApps.some(app => previousAppChoices[app.id] && !app.skippable)

  const isAnyAppSelected = recommendedApps.some(
    (app) => app.enabled
  )

  let customText = {}

  if(isSkippable && isAnyAppSelected) {
    customText = {
      text: "Next",
      next: "Review"
    }
  }

  useEffect(() => {
    let updatedAppList = [...recommendedApps]
    const previousAppChoices = JSON.parse(appChoices ?? "{}")

    updatedAppList = updatedAppList.map((app) => {
      if (isStoreOnboardingComplete) {
        return { ...app, enabled: true, disabled: true };
      }
  
      if (previousAppChoices[app.id]) {
        return { ...app, enabled: true, disabled: true };
      }
  
      return app;
    })
  
    setPreviousAppChoices(previousAppChoices)
    setRecommendedApps(updatedAppList);
  }, [fetchedStoreOnboarding]);

  if(fetchingStoreOnboarding) {
    return (
        <AppsContainer
          title={title}
          subtitle={subtitle}
          handleExitToEditor={handleExitToEditor}
        >
          <Card
            sx={{
              border: '1px solid #C0C4CF',
              py: '12px',
              px: '12px',
            }}
            elevation={0}
          >
            <CardContent>
              <Typography variant="h6" textAlign="left" className="!mb-5">
                Recommended applications
              </Typography>
  
              <Box className="flex flex-col gap-6">
                {recommendedApps?.map((_, index) => (
                  <Box key={index} className="flex gap-4">
                    <Skeleton variant="rectangular" width={40} height={40} />
                    <Box className="flex-1">
                      <Skeleton variant="text" height={32} />
                      <Skeleton variant="text" width="60%" height={20} />
                    </Box>
                  </Box>
                ))}
              </Box>
            </CardContent>
          </Card>
        </AppsContainer>
      )
    }
  
  return (
    <AppsContainer
      title={title}
      subtitle={subtitle}
      handleExitToEditor={handleExitToEditor}
    >
      <Box className="mx-1 md:mx-0 max-h-screen pb-16">
        <Card
          sx={{
            border: '1px solid #C0C4CF',
            mb: '12px',
          }}
          elevation={0}
        >
          <CardContent className='!p-4 md:!p-6'>
            <Typography
              variant='h6'
              textAlign={'left'}
              className='!mb-5'
            >
              Recommended applications
            </Typography>
            <Box className='flex flex-col gap-6'>
              {recommendedApps.map((app, index) => {
                return (
                  <RecommendedApp
                    key={app.name}
                    onToggle={updateSelectedApp}
                    {...app}
                    index={index}
                    hide={shouldHideApp(app.id)}
                  />
                )
              })}
            </Box>
          </CardContent>
        </Card>
        <Box className="fixed bottom-0 left-0 right-5 md:static">
          <WizardFooter skip={isSkippable} customText={customText} />
        </Box>
      </Box>
    </AppsContainer>
  )
}

export default RecommendedApps
